import React from 'react';
import { PopNotificationCardProps } from 'components/PopNotificationCard/PopNotificationCard.component';
import PopNotificationCard from 'components/PopNotificationCard';
import { render, unmountComponentAtNode } from 'react-dom';

export type NotificationConfig = PopNotificationCardProps;

const CONTAINER_CLASS = 'notif-container';

export default (config: NotificationConfig) => {
  const { notification, onClick, onCtaClick, ...rest } = config;
  const span = document.createElement('span');
  span.classList.add(CONTAINER_CLASS);
  document.body.appendChild(span);

  const cleanUp = () => {
    document.body.removeChild(span);
    unmountComponentAtNode(span);
  };

  render(
    <PopNotificationCard
      {...rest}
      notification={notification}
      onClick={onClick}
      onClose={() => cleanUp()}
      onCtaClick={async () => {
        await onCtaClick?.();
        cleanUp();
      }}
    />,
    span,
  );
};
